import { AxiosError, AxiosInstance } from 'axios'
import { logoutUserAction } from 'utils/alertUser'

const onResponseError = (error: AxiosError): Promise<AxiosError> => {
  const session = window.sessionStorage.getItem('userSession')
  const sessionObj = session && JSON.parse(session)
  if (error.response?.status === 401 && sessionObj.authenticated) {
    logoutUserAction()
  }

  return Promise.reject(error)
}

export function setupInterceptorsTo(axiosInstance: AxiosInstance): AxiosInstance {
  axiosInstance.interceptors.response.use(undefined, onResponseError)
  return axiosInstance
}
